// src/features/analytics/AnalyticsWorkspacePage.tsx
import { LoadingBoundary, PageContainer } from '../../app/components/foundation';
import { AnalyticsHeader, AnalyticsLiveOverview } from './components';
import { useAnalytics } from './hooks/useAnalytics';
import './styles/analytics.css';

/**
 * Analytics Workspace Foundation (/analytics/:id). Same shell pattern
 * as MonitoringWorkspacePage/CommissionWorkspacePage/
 * AuditWorkspacePace: PageContainer + feature-owned header, card grid
 * below, RTL/Persian throughout, existing tokens/primitives only.
 *
 * Reads `id` from the route params and resolves everything through
 * useAnalyticsWorkspaceMock(id) — the analytics record plus its
 * overview/revenue/users/services/performance/timeline, all still
 * mock data from data/analytics.mock.ts. No API calls;
 * useAnalyticsWorkspaceMock is the seam a later phase swaps for a
 * real analytics-detail hook without touching this file or the cards
 * below it (same shape).
 */
export function AnalyticsWorkspacePage() {
  const { analytics, loading, error } = useAnalytics();

  return (
    <PageContainer className="flex flex-col gap-6">
      <AnalyticsHeader />
      <LoadingBoundary loading={loading} error={error}>
        {analytics ? <AnalyticsLiveOverview analytics={analytics} /> : null}
      </LoadingBoundary>
    </PageContainer>
  );
}
